import { StorageConstants, VerifyOtpTypes } from "../../constants/Constants";
import ResetPasswordModel from "./ResetPasswordModel";

import React, { useEffect, useRef, useState } from "react";
import Button from "../Ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { VerifyMailType } from "../../constants/Constants";
import {
  getFromStorage,
  handleBackspaceAndEnter,
  saveToStorage,
} from "../../utils/Helper";
import {
  ResendOtpAction,
  ResetPasswordAction,
  VerifyOtpAction,
} from "../../redux/Action/AuthAction";
import $ from "jquery";
import { Config } from "../../config/Config";
import { GetProfileAction } from "../../redux/Action/ProfileAction";
import { ImageContainer } from "../../constants/ImagesConstants";
import { FormattedMessage } from "react-intl";

const OtpModel = ({ payload }: any) => {
  const local_language = localStorage.getItem("lang");

  const OtpVerify = useSelector((state: any) => state.VerifyOtpState);
  let countdown: any;
  const dispatch = useDispatch<any>();
  const numberOfDigits = 4;
  const regex = /^[0-9\b]+$/;
  const otpBoxRef = useRef<any>([]);

  const initialTime = 120;
  const [timer, setTimer] = useState(initialTime);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [otp, setOtp]: any = useState(new Array(numberOfDigits).fill(""));
  const [isResendOtp, setIsResendOtp] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [otpData, setOtpData]: any = useState("");

  const handleChange = (value: any, index: any) => {
    setOtpError("");
    if (value === "" || regex.test(value)) {
      let newArr = [...otp];
      newArr[index] = value;
      setOtp(newArr);
      setOtpData(newArr.join(""));
    }

    if (value && regex.test(value) && index < numberOfDigits - 1) {
      otpBoxRef.current[index + 1].focus();
    }
  };

  const onPaste = (event: any) => {
    const pasted = event.clipboardData.getData("text/plain");
    if (pasted.length === numberOfDigits && regex.test(pasted)) {
      setOtpError("");
      setOtpData(pasted);
      setOtp(pasted.split("").slice(0, numberOfDigits));
    }
  };

  useEffect(() => {
    if (isTimerRunning && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(countdown);
      setIsTimerRunning(false);
    }
    return () => {
      clearInterval(countdown);
    };
  }, [isTimerRunning, timer]);

  const startTimer = () => {
    setIsTimerRunning(true);
    setTimer(initialTime);
  };

  useEffect(() => {
    if (payload && isResendOtp === false) {
      startTimer();
    }
    if (!payload) {
      setIsTimerRunning(false);
      setIsResendOtp(false);
    }
  }, [payload]);

  const handleVerify = () => {
    if (otp.join("") == "" || otpData?.length < 4) {
      return setOtpError(
        local_language == "alb"
          ? "Ju lutemi shkruani OTP."
          : "Please enter OTP.",
      );
    }
    setOtpError("");

    let data = {
      email: payload?.email,
      otp: otpData,
      verify_type: payload?.type,
    };
    dispatch(VerifyOtpAction(data));
  };

  const handleResendOtp = () => {
    setIsResendOtp(true);
    setOtp(new Array(numberOfDigits).fill(""));
    startTimer();

    const data = {
      email: payload?.email,
      verify_type: payload?.type,
    };
    dispatch(ResendOtpAction(data));
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleVerify();
    }
  };

  const resetPasswordButton: any = useRef(null);

  const [data, setData]: any = useState(null);
  useEffect(() => {
    if (OtpVerify?.status && payload?.type == VerifyMailType?.MailVerify) {
      const fetch = async () => {
        saveToStorage({
          key: StorageConstants?.IS_USER_LOGIN_TOKEN,
          value: OtpVerify?.data?.access_token,
        });
        saveToStorage({
          key: StorageConstants?.USER_DETAIL,
          value: OtpVerify?.data?.data,
        });
        Config.IS_USER_LOGIN_TOKEN = OtpVerify?.data;

        if (getFromStorage({ key: StorageConstants?.IS_USER_LOGIN_TOKEN })) {
          // navigate('/profile')
          window.location.href = Config?.BASE_URL + "/profile";
        }
      };
      fetch();
    } else {
      if (OtpVerify?.status) {
        if (resetPasswordButton.current) {
          resetPasswordButton.current.click();
          const payload_data = {
            email: payload?.email,
            type: payload?.type,
            otp: otpData,
          };

          setData(payload_data);
        }
      }
    }
  }, [OtpVerify]);

  useEffect(() => {
    $(".otpModelClose").click();
  }, [data]);

  return (
    <>
      <div
        className="modal modelStyle fade"
        id="OTPVerify"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        data-bs-backdrop="static"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog  modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="btnClose otpModelClose"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setOtpError("");
                  setOtp(new Array(numberOfDigits).fill(""));
                  payload?.setOnModelClose(true);
                }}
              >
                <span className="icon-close"></span>
              </button>
              <div className="row">
                <div className="col-md-6 mx-auto text-center">
                  <div className="modelLogo">
                    <img src={ImageContainer?.Logo} />
                  </div>
                  <h2>{<FormattedMessage id="otp_verfiy" />}</h2>
                  <p>
                    {<FormattedMessage id="first_message_verification" />}
                    <br /> {<FormattedMessage id="was_just_sent" />}
                    {payload?.email.split("@")[1]}
                  </p>
                  <div className="otpInput">
                    {otp.map((digit: any, index: any) => {
                      return (
                        <input
                          className="form-control"
                          key={index}
                          value={digit}
                          onPaste={onPaste}
                          maxLength={1}
                          ref={(ref) => (otpBoxRef.current[index] = ref)}
                          type="text"
                          placeholder="*"
                          onChange={(e) => handleChange(e.target.value, index)}
                          onKeyDown={handleKeyDown}
                          onKeyUp={(e) =>
                            handleBackspaceAndEnter(
                              e,
                              index,
                              otpBoxRef,
                              numberOfDigits,
                            )
                          }
                        />
                      );
                    })}
                  </div>
                  <p className="text-danger mt-3"> {otpError}</p>
                  {/* <FormattedMessage id="" /> */}
                  {timer > 0 && (
                    <p className="color-p fw-600 mt-3">
                      <FormattedMessage id="resend_in" />: {timer}{" "}
                      <FormattedMessage id="sec" />
                    </p>
                  )}
                  {OtpVerify?.status &&
                    payload?.type == VerifyMailType?.ForgetPasswordVerify && (
                      <button
                        type="button"
                        onClick={() => dispatch(ResetPasswordAction("RESET"))}
                        style={{ display: "none" }}
                        className="btn btn-fill mb-4"
                        data-bs-target="#ResetPassword"
                        data-bs-toggle="modal"
                        ref={resetPasswordButton}
                      >
                        Submit
                      </button>
                    )}

                  <Button
                    onClick={handleVerify}
                    text={(<FormattedMessage id="Verify" />) as any}
                    className="btn btn-fill w-100"
                    isLoading={OtpVerify?.loading}
                  />

                  {timer === 0 && (
                    <Button
                      type="button"
                      text={(<FormattedMessage id="resend" />) as any}
                      className="btn text-decoration-underline fw-600 mt-3"
                      onClick={handleResendOtp}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ResetPasswordModel resetData={data} />
    </>
  );
};
export default React.memo(OtpModel);
